module.exports = __webpack_public_path__ + "img/curtainOpen.daaa8ec3.svg";